import { createStyles } from '@mantine/core';

export default createStyles(theme => ({
  navContainer: {
    fontWeight: 500,
    fontSize: theme.fontSizes.sm,
    display: 'block',
    padding: '0 12px 0 14px',
    margin: '4px 0',
  },
  subNavContainer: {
    display: 'block',
    paddingLeft: 26,
  },
  navLink: {
    color: theme.white,
    textDecoration: 'none',
    display: 'block',
    padding: '6px 0',
    margin: '2px 0',
    borderRadius: theme.radius.sm,
    '&:hover': {
      color: theme.other.colors.bgDark,
      backgroundColor: theme.other.colors.highLightBlue,
    },
  },
  linkActive: {
    color: theme.other.colors.bgDark,
    backgroundColor: theme.other.colors.highLightBlue,
    borderRadius: theme.radius.sm,
  },
  navMenuCollapse: {
    color: theme.white,
    padding: '10px 0',
    borderRadius: theme.radius.sm,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.other.colors.appDarkBlue,
    },
  },
  navMenu: {
    color: theme.white,
    padding: '10px 0',
  },
  chevron: {
    transition: 'transform 200ms ease',
    marginRight: 8,
  },
}));
